module.exports = __webpack_public_path__ + "596b0c101a69bf1c9e38d535d84c73c9.png";